import { useState } from "react";
import googleAds from "../../components/images/webp/google-ads.webp"; 
import phoneIcon from "../../components/images/svg/phone-icon.svg"; 
import emailIcon from "../../components/images/svg/email-icon.svg"; 
import downIcon from "../../components/images/svg/download-icon.svg"; 
import PrimaryButton from "../../components/PrimaryButton"; 
import downloadIcon from "../../components/images/svg/download-icon.svg"; 
import blurredRecordSample from "../../components/images/png/blurredRecordSample.png"
import { HeadingVector } from "./Icons";
import axios from '../../backendClient'; 


const SAMPLE_NICHES = [
  { value: "beauty", label: "Beauty Brands" },
  { value: "supplements", label: "Supplement Brands" },
  { value: "pet", label: "Pet Brands" },
  { value: "fashion", label: "Fashion Brands" },
  { value: "shopify", label: "Shopify Brands" },
  { value: "medSpas", label: "Med Spas (running ads)"},
  { value: "lawFirms", label: "Law Firms (running ads)"},
  { value: "techCompanies", label: "Recently Funded Tech Companies"},
  { value: "hiringReps", label: "Companies Hiring Sales Reps"},
  { value: "custom", label: "I need a custom list"}];

const SAMPLE_ROOMS = {
  beauty: {
    label: "Beauty Brands",
    sampleRoomUrl: "/single/sample-beauty-brands",
  },
  supplements: {
    label: "Supplement Brands",
    sampleRoomUrl: "/single/sample-supplement-brands-running-meta-ads",
  },
  pet: {
    label: "Pet Brands",
    sampleRoomUrl: "/single/sample-pet-brands",
  },
  fashion: {
    label: "Fashion Brands",
    sampleRoomUrl: "/single/sample-fashion-brands",
  },
  shopify: {
    label: "Shopify Brands",
    sampleRoomUrl: "/single/sample-shopify-brands",
  },
  medSpas: {
    label: "Med Spas (running ads)",
    sampleRoomUrl: "/single/sample-med-spas-running-ads",
  },
  lawFirms: {
    label: "Law Firms (running ads)",
    sampleRoomUrl: "/single/sample-law-firms-running-ads",
  },
  techCompanies: {
    label: "Recently Funded Tech Companies",
    sampleRoomUrl: "/single/sample-recently-funded-tech-companies",
  },
  hiringReps: {
    label: "Companies Hiring Sales Reps",
    sampleRoomUrl: "/single/sample-companies-hiring-sales-reps",
  },
  custom: {
    label: "I need a custom list",
    sampleRoomUrl: "https://calendly.com/incentive-meet/30min"
  }
};

const SAMPLE_ROOM_OPTIONS = Object.entries(SAMPLE_ROOMS).map(
  ([value, config]) => ({
    value,
    label: config.label,
  })
);


const getSampleRoomByNiche = (niche) => {
  return SAMPLE_ROOMS[niche] || null;
};


const BusinessForm = () => {

    const [niche, setNiche] = useState(''); 
    const [email, setEmail] = useState(''); 
    const [infoSubmit, setInfoSubmit] = useState(false); 
    const [sampleRoomUrl, setSampleRoomUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState("");




    const handleInputChange = (e) => {
        const {name, value} = e.target; 
        if(name === 'niche'){
            setNiche(value); 
            // alert(value); 
        }else if (name === 'email'){
            setEmail(value); 
        }
    }

    const handleSubmit = async (e) => {
      e.preventDefault();
    
      setFormError("");
    
      const selectedRoom = getSampleRoomByNiche(niche);
    
      if (!selectedRoom) {
        setFormError("Choose a niche first.");
        return;
      }
    
      if (!email) {
        setFormError("Enter your email.");
        return;
      }
    
      // Frontend fallback so the button works even before backend is finished
      setSampleRoomUrl(selectedRoom.sampleRoomUrl);
    
      try {
        setLoading(true);
    
        // const response = await axios.post("/api/listRoom/sample-request", {
        //   niche,
        //   email,
        //   sampleRoomUrl: selectedRoom.sampleRoomUrl,
        //   nicheLabel: selectedRoom.label,
        //   sourcePage: window.location.pathname,
        //   pageUrl: window.location.href,
        //   utmSource: new URLSearchParams(window.location.search).get("utm_source"),
        //   utmCampaign: new URLSearchParams(window.location.search).get("utm_campaign"),
        //   utmContent: new URLSearchParams(window.location.search).get("utm_content"),
        // });

        let response = null; 
    
        // Backend can override the frontend config later
        setSampleRoomUrl(
          response?.data?.sampleRoomUrl || selectedRoom.sampleRoomUrl
        );
    
        setInfoSubmit(true);
      } catch (error) {
        console.error("Sample request error:", error);
    
        // Temporary dev behavior: still let them open the sample room
        setInfoSubmit(true);
    
        // Once backend is live, replace this with:
        // setFormError(error?.response?.data?.message || "Something went wrong. Try again.");
      } finally {
        setLoading(false);
      }
    };

    const handleSubmitOld = async (e) => {
        e.preventDefault();
        if (niche && email) {
          try {
            //** TO DO CREATE AND STORE LEADS IN BACKEND */
            // Save data to your backend if needed
            // Post data to backend endpoint
            //const response = await axios.post('/storeLeads', { phone, email });
            // handle response data if needed
            //console.log(response.data);
    
            setInfoSubmit(true);
          } catch (error) {
            console.error('Error:', error);
          }
        }
      };

    return (
      <>
        <div id="business-form" className="position-relative z-1">
          <div className="position-absolute end-0 z-n1 business_form_shadow rounded-pill business_top_shadow"></div>
          <div className="position-absolute start-0 z-n1 business_form_shadow rounded-pill business_bottom_shadow"></div>
          <div className="container container_modified">
            <h5 className="form_heading fw-bolder text-center z-1 position-relative mb-3 text-black mx-auto">
             Get a 5-row Sample Contacts In A ListRoom 
              <span className="position-absolute start-50 translate-middle-x z-n1 form_heading_vector">
                <HeadingVector />
              </span>
            </h5>
            <p className="text-center font-md text-black mb-lg-5 mb-4 form_paragraph mx-auto">
            Choose a target market/niche and we’ll send a masked sample so you can see the format before buying or requesting a custom list.
            </p>
            <div className="row strategy_card align-items-center bg-white">
              <div className="col-md-6 col-12 px-0 text-center text-md-start">
                <div className="strategy_win_image mx-auto mx-md-0 overflow-hidden rounded-3">
                  <img
                    src={blurredRecordSample}
                    alt="strategy-win"
                    className="rounded-3 w-100 transition_03s"
                  />
                </div>
              </div>

              
              <div className="col-md-6 col-12 mt-3 mt-md-0 pt-1 pt-md-0 px-0">
                <div className="form_card">
                  <form onSubmit={handleSubmit}>
                    <label htmlFor="niche" className="text-black font-sm">
                      Preferred Niche (ex. Fitness Brands)
                    </label>{" "}
                    <br />


                  <div className="form_input bg-white d-flex align-items-center gap-1 mt-2">
                    <img
                      src={downIcon}
                      alt="down-icon"
                      width={19}
                      height={19}
                    />

                    <select
                      id="niche"
                      name="niche"
                      value={niche}
                      onChange={handleInputChange}
                      className="border-0 bg-transparent w-100 font-md"
                      style={{ outline: "none" }}
                    >
                      <option value="">Choose your niche</option>
                      {SAMPLE_NICHES.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>


                    <label
                      htmlFor="email"
                      className="text-black font-sm mt-lg-4 mt-3"
                    >
                      Email
                    </label>
                    <br />
                    <div className="form_input bg-white d-flex align-items-center gap-1 mt-2">
                      <img
                        src={emailIcon}
                        alt="phone-icon"
                        width={19}
                        height={14}
                      />
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleInputChange}
                        placeholder="Your email"
                        className="border-0 bg-transparent w-100 font-md"
                      />
                    </div>
                    <div className="btn_download mt-lg-4 mt-3 mb-lg-3">
                    {/* {!infoSubmit && (
                                     <PrimaryButton
                                     text="Get My Sample Data"
                                     btnStyle="fw-bold w-100 d-inline-block"
                                   />
                    )} */}

{!infoSubmit && (
  <PrimaryButton
    text={loading ? "Sending..." : "Send My 5 Sample Contacts"}
    btnStyle="fw-bold w-100 d-inline-block"
  />
)}
                    {infoSubmit && (
          <PrimaryButton
    text={niche==="custom"?"Schedule A Meeting":"Open My Sample ListRoom"}
    btnStyle="fw-bold w-100 d-inline-block"
    target="_blank"
    url={sampleRoomUrl || "/search"}
    icon={
      <span className="ps-2">
        <img
          src={downloadIcon}
          alt="icon"
          width={15}
          height={18}
        />
      </span>
    }
  />
)}       
                    {/* {infoSubmit && (
                      <PrimaryButton
                        text="Thanks! Download Your Book"
                        btnStyle="fw-bold w-100 d-inline-block"
                        target="_blank"
                        url="https://incentiveweb.s3.amazonaws.com/book/_+3+Google+Ads++Success+For+Business+Owners+By+IncentiveMeet.pdf"
                        icon={
                          <span className="ps-2">
                            <img
                              src={downloadIcon}
                              alt="icon"
                              width={15}
                              height={18}
                            />
                          </span>
                        }
                      />
                    )} */}
                    </div>
                  </form>
                  <div className="col-12 mt-3 mt-md-0 pt-1 pt-md-0 px-0">We’ll send a small preview. The full list includes 50 brands, websites, contact info when available, and notes to help you pitch.</div>   
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default BusinessForm;
  